const temeout = {
    elements: [], 

    init() {
       this.setCounter()
    },
   
    setCounter() {
        setTimeout(()=> {             
            document.body.classList.remove('hidePopups');
          
        },10000);
       
    }

}

export default temeout;